var map = {
	"./BOOST.svg": 2353,
	"./GRAB.svg": 2354,
	"./MBB.svg": 2355,
	"./TNG.svg": 2356,
	"./direpay.svg": 2357,
	"./doitnow.svg": 2358,
	"./duitnow.svg": 2359,
	"./fpay.svg": 2360,
	"./fpay2.svg": 2361,
	"./fpx.svg": 2362,
	"./online_banking.svg": 2363,
	"./rapidpays.svg": 2364,
	"./secret_pay.svg": 2365,
	"./secret_pay_offline.svg": 2366,
	"./secret_pay_pro.svg": 2367,
	"./secret_pay_pro_b.svg": 2368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;